/* eslint-disable */
import getMuiTheme from 'material-ui/styles/getMuiTheme'

const purpleBlue = '#00244D'
const lightOrange = '#EB9413'
const lightYellow = '#FDC426'
const mediumYellow = '#FFCA28'
const mediumOrange = '#F28DI5'
const darkOrange = '#EB6B0A'
const lightBlue = '#0095F7'
const darkBlue = '#003896'
const grey = '#737882'

export default getMuiTheme({
  palette: {
    primary1Color: purpleBlue,
    // primary2Color: lightOrange,
    // primary3Color: lightYellow,
    accent1Color: lightOrange
    // accent2Color: lightBlue,
    // accent3Color: lightBlue,
    // textColor: grey,
    // canvasColor: lightOrange,
    // borderColor: darkBlue,
    // pickerHeaderColor: 'green',
    // clockCircleColor: 'cyano',
    // shadowColor: 'blue',
  }
})



// WEBPACK FOOTER //
// ./src/utils/litrozTheme.js